var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_shadow"},[_c('div',{staticClass:"modal_wrap"},[_vm._t("content"),_c('div',{staticClass:"close_btn",on:{"click":_vm.closeModal}},[_vm._v(_vm._s(_vm.$t("common.close")))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }